var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute z-50 flex flex-col invisible w-auto min-w-full px-3 py-3 bg-gray-900 rounded-b-lg shadow-xl group-hover:visible"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }